export default[
    {
        path: '/collectMoney/memberRecharge',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '会员充值',
            keepAlive: false
        }
    }
]